import * as React from "react";
const StarMobile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={10}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <path
          fill="#DAA520"
          d="M5.6 1.066a.561.561 0 0 0-1.013 0l-1.13 2.326-2.525.373a.561.561 0 0 0-.313.956l1.832 1.812-.432 2.561a.564.564 0 0 0 .82.591l2.256-1.204L7.35 9.685a.563.563 0 0 0 .82-.59l-.433-2.562 1.831-1.812a.562.562 0 0 0-.313-.956L6.73 3.392 5.6 1.066Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.031.75h10.125v9H.031z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M.031.75h10.125v9H.031v-9Z" />
      </clipPath>
    </defs>
  </svg>
);
export default StarMobile;
